import React from 'react'
import StudentModal from '../StudentModal/StudentModal'
import NewStudentModal from '../NewStudentModal/NewStudentModal'
import {AreYouSure} from '../AreYouSure/AreYouSure'
import {ErrorPopup} from '../ErrorPopup/ErrorPopup'
import NewLoadingScreen from '../NewLoadingScreen/NewLoadingScreen'
import { baseUrl } from '../assets/Animations'
import useFetch from '../hooks/useFetch'
import loadingping from '../img/loadingpin.svg'
import "./student-database.css"



import {gql, useMutation } from '@apollo/client';
import MissingStudentRatePopup from './MissingStudentRatePopup/MissingStudentRatePopup'
//import { setContext } from '@apollo/client/link/context';

const StudentDatabase = (props) => {
    const [studentData, setStudentData]= React.useState([])
    const [modal, setModal]= React.useState(false)
    const [newStudent, setNewStudent]= React.useState(false)
    const [nameQuery, setNameQuery]= React.useState('')
    const [statusQuery, setStatusQuery]= React.useState('')
    const [schoolQuery, setSchoolQuery]= React.useState('')
    const [teacherQuery, setTeacherQuery]= React.useState('')
    const [phoneNumberQuery, setPhoneNumberQuery] = React.useState('')
    const [instrumentQuery, setInstrumentQuery] = React.useState('')
    const [background, setBackground]= React.useState('background-1.jpg')
    const [areYouSure, setAreYouSure]= React.useState(false)
    const [error, setError]= React.useState(false)
    const [currentOpenStudents, setCurrentOpenStudents] = React.useState([])
    const [totals, setTotals] = React.useState({'MMA': 0, 'LSMA': 0, 'TMA': 0, 'MOR': 0})
    const [closingModal, setClosingModal] = React.useState(false)
    const [missingRatesPopup, setMissingRatesPopup] = React.useState(false)
    const [instrumentTotals, setInstrumentTotals] = React.useState({})
    const [totalInst, setTotalInst] = React.useState(0)

    const {data: teachers, loading: gettingTeachers, error: testError} = useFetch(`${baseUrl}/initialadminrequest`)
    const {data: instruments, loading: gettingInstruments, error: testInstError} = useFetch(`${baseUrl}/inst`)
    const {data: allStudents, loading: gettingStudents, error: testStudentError, reFetch, callPost, callPut, updateItem, callDelete, pushItem, deleteItem} = useFetch(`${baseUrl}/school-management`)
      
    let CREATE_CUSTOMER = gql`mutation ($input: CustomerCreateInput!) {
        customerCreate(input: $input) {
          didSucceed
          inputErrors {
            code
            message
            path
          }
          customer {
            id
            name
            firstName
            lastName
            email
            address {
              addressLine1
              addressLine2
              city
              province {
                code
                name
              }
              country {
                code
                name
              }
              postalCode
            }
            currency {
              code
            }
          }
        }
      }`    
    const [createCustomer] = useMutation(CREATE_CUSTOMER)

    React.useEffect(() => {
        closingModal ? document.body.style.cursor = 'wait' : document.body.style.cursor = 'pointer' 
    }, [closingModal])

    React.useEffect(() => {
        if(teachers) {
            generateTeacherFilterList()
            generateInstrumentFilterList()
        }
    }, [teachers])

    React.useEffect(() => {
        schoolQuery === '' ? setBackground(`ALL.jpg`) : setBackground(`${schoolQuery}.jpg`)  
        setTeacherQuery('')
        if(teachers) {
            generateTeacherFilterList()
        }
        if(allStudents) {
            wholeFilter()
        }
    }, [schoolQuery])

    React.useEffect(() => {
        if(allStudents) {
            wholeFilter()

        }
    }, [statusQuery, teacherQuery, nameQuery, instrumentQuery, phoneNumberQuery])

    React.useEffect(() => {
        if(allStudents) {
            generateTotals()
            wholeFilter()
            setTheDropdownDisplayForFamiliesStatus(allStudents)
            tallyUpStudentsByInstrument(allStudents)
        }
    }, [allStudents])

    const openStudentModal = (id) => {
        for(let i = 0; i < studentData.length; i++) {
            if(studentData[i].familyId === id) {
                setModal(studentData[i])
                props.getNotesAboutModal(studentData[i].familyId, 'familyId', studentData[i].familyName)
            }
        }
    }
    const closeStudentModal = async (id) => {
        //LOOP THROUGH STUDENTS AND MAKE SURE ALL OF THEM HAVE RATES THAT ARE NOT 0
        let missingStudentRates = false
        for(let i = 0; i < modal.students.length; i++) {
            if(modal.students[i].allRates[15] === 0 || modal.students[i].allRates[30] === 0 || modal.students[i].allRates[45] === 0 || modal.students[i].allRates[60] === 0 ) {
                missingStudentRates = true
            }
        }
        if(missingStudentRates) {
            setMissingRatesPopup(true)
        } else {
            setClosingModal(true)
            let infoToSend = modal
            if(modal.familyStatus === 'Active') {
                //MAKE A NEW WAVE ID FOR NEW FAMILY
                infoToSend.waveCustomerId = infoToSend.waveCustomerId ? infoToSend.waveCustomerId : await makeANewWaveClient(modal)
                //---------------------------------
                callPut(`${baseUrl}/school-management-new/${infoToSend.familyId}`, infoToSend, myPutCallback, 'familyId')
            } else {
                callPut(`${baseUrl}/school-management-new/${infoToSend.familyId}`, infoToSend, myPutCallback, 'familyId')
            }
            setClosingModal(false)
            setModal(false)
            props.closeSideNotesWithAnimation()
        }
    }
    const myPutCallback = (data, id) => {
        props.getFamiliesToWatch()
        updateItem(data, id)
    }
    const removeTheFamily = () => {
        callDelete(`${baseUrl}/school-management/${areYouSure}`, myDeleteCallback, 'familyId')
        setAreYouSure(null)
        setModal(false)
        props.closeSideNotesWithAnimation()
    }
    const myDeleteCallback = (data, id) => {
        props.getFamiliesToWatch()
        deleteItem(data, id)
    }
    const editStudentInfo = (theIndex, key, theChange, id) => {
        let student;
        if(newStudent) {
            student = newStudent
            if(key === "addressLine1" || key === "city" || key === "state" || key === "zipcode" || key === "addressLine2") {
                student.address[key] = theChange  
            } else if (id === 'allRates') {
                student.students[theIndex].allRates[key] = theChange
            } else if (id === 'new-instrument') {
                student.students[theIndex].instrumentList = theChange
            } else {
                id === "student-info" ? student.students[theIndex][key] = theChange : student[key] = theChange
            }
            setNewStudent({...student})
        } else {
            student = modal
            if(key === "addressLine1" || key === "city" || key === "state" || key === "zipcode" || key === "addressLine2") {
                student.address[key] = theChange
            } else if (id === 'allRates') {
                student.students[theIndex].allRates[key] = theChange
            } else if (id === 'new-instrument') {
                student.students[theIndex].instrumentList = theChange
            } else {
                id === "student-info" ? student.students[theIndex][key] = theChange : student[key] = theChange
            }
            setModal({...student})
        }

    }
    const wholeFilter = () => {
        let masterList = allStudents
        if(schoolQuery) {
            masterList = masterList.filter(family => family.school === schoolQuery)
        }
        if(statusQuery) {
            masterList = masterList.filter(family => {
                for(let i = 0; i < family.students.length; i++) {
                    if(family.students[i].studentStatus === statusQuery) {
                        return family
                    }
                }
                if(family.familyStatus === statusQuery && family) {
                    return family
                }
            })
        }
        if(teacherQuery) {
            masterList = masterList.filter(family => {
                for(let i = 0; i < family.students.length; i++) {
                    return family.students[i].teachersId === teacherQuery
                }
            })
        }
        if(nameQuery) {
            masterList = masterList.filter(family => {
                let wholeName = "";
                if(family.familyName) {
                    wholeName = wholeName + family.familyName.toString().toLowerCase()
                }
                for(let i = 0; i < family.students.length; i++) {
                    if(family.students[i].studentName) {
                        wholeName = wholeName + family.students[i].studentName.toString().toLowerCase()
                    }
                }
                return wholeName.includes(nameQuery.toLowerCase())
            })
        }
        if(instrumentQuery) {
            masterList = masterList.filter(family => {
                for(let i = 0; i < family.students.length; i++) {
                    for(let j = 0; j < family.students[i].instrumentList.length; j++) {
                        if(instrumentQuery === family.students[i].instrumentList[j].parentInstrument) {
                            return family
                        }
                    }
                }
            })
        }
        if(phoneNumberQuery) {
            masterList = masterList.filter(family => {
                let strippedNumber = ""
                if(family.primaryCellphone) {
                    strippedNumber = family.primaryCellphone.replace(/[^0-9]/g, '')
                }
                return strippedNumber.includes(phoneNumberQuery.replace(/[^0-9]/g, ''))
            })
        }
        setStudentData([...masterList])
    }
    const setTheDropdownDisplayForFamiliesStatus = (list) => {
        for(let i = 0; i < list.length; i++) {
            if(document.getElementById("status-dropdown-" + list[i].familyId)) {
                document.getElementById("status-dropdown-" + list[i].familyId).value = list[i].familyStatus
            }
        }
    }
    const massCheck = (isChecked) => {
        let theBoxes = document.getElementsByClassName('student-checkbox')
        if(isChecked) {
            for(let i = 0; i < theBoxes.length; i++){
                theBoxes[i].checked = true
            }
        } else {
            for(let i = 0; i < theBoxes.length; i++){
                theBoxes[i].checked = false
            }
        }
    }
    const copyAttempt = () => {
        let theList = ''
        let theBoxes = document.getElementsByClassName('student-checkbox')
        for(let i = 0; i < theBoxes.length; i++) {
            if(theBoxes[i].checked === true) {
                theList = theList + ' ' + theBoxes[i].value + ';'
            }
        }
        navigator.clipboard.writeText(theList)
        setTimeout(function(){
            alert("Emails have been copied to you clipboard")
        }, 0)
    }
    const openNewFamily = () => {
        setNewStudent({
                familyId: Math.random().toString(16).slice(2),
                familyName: '',
                waveCustomerId: '',
                students: [{
                    studentId: Math.random().toString(16).slice(2),
                    studentName: '',
                    dob: '',
                    instrument: '',
                    instrumentList: [],
                    teachersId: '',
                    lessonLength: 0,
                    lessonRate: 0,
                    allRates: {15: 22, 30: 45, 45: 60, 60: 75},
                    studentStatus: "Active",
                    studentNotes: ''
                }],
                address: {
                  addressLine1: '',
                  addressLine2: '',
                  city: '',
                  state: '',
                  zipcode: 0
                },
                primaryParentName: '',
                secondaryParentName: '',
                school: '',
                primaryEmail: '',
                secondaryEmail: '',
                primaryCellphone: '',
                secondaryCellphone: '',
                primaryHomePhone: '',
                secondaryHomePhone: '',
                familyStatus: 'Active',
                familyNotes: '',
                hearOfUs: '',
                onboardDate: new Date(),
                paymentType: '',
                autoPay: false,
                moreAttention: false,
                policiesSigned: false,
                groupLessons: false,
                introLesson: false,
                membership: 0,
                password: 'password',
                purchased: []
              })
    }
    const addAStudent = () => {
        let currentFamily = modal ? modal : newStudent      
        currentFamily.students.push({
            studentId: Math.random().toString(16).slice(2),
            studentName: '',
            dob: '',
            instrument: '',
            instrumentList: [],
            teachersId: '',
            lessonLength: 0,
            lessonRate: 0,
            allRates: {15: 0, 30: 0, 45: 0, 60: 0},
            studentStatus: "Active",
            studentNotes: ''
        })
        modal ? setModal({...currentFamily}) : setNewStudent({...currentFamily})
    }

    const makeANewWaveClient = async (theNewStudent) => {
        let businessId;
        let stateCode;
        //if(theNewStudent.familyStatus === "Active") {
            if(theNewStudent.school === 'MMA') {
                businessId = "QnVzaW5lc3M6ZDVlMTRiODMtZDM1OC00MzVlLWI3ZWQtMzU2ZjAzNDAzYzBh"
                stateCode = 'US-CO'
            } else if (theNewStudent.school === 'LSMA') {
                businessId = "QnVzaW5lc3M6NGYxNWJhZGItYTc4Zi00ZjIxLWE2MDEtYmY0YjA2ZDVlNzk2"
                stateCode = 'US-MN'
            } else if (theNewStudent.school === 'TMA') {
                businessId = "QnVzaW5lc3M6OGMyMGUyN2YtZTQ2MC00ZGI2LWI1M2ItNGNhNzMxYTMyNDky"
                stateCode = 'US-MI'
            } else if (theNewStudent.school === 'MOR') {
                businessId = "QnVzaW5lc3M6MjgxYzUwZmQtMjg0Yi00MzMyLTk5NjEtN2Y3MjNkMDRkZmQw"
                stateCode = 'US-OR'
            } else {
                alert('Please choose a school!')
                return
            }
        //}

        let zipCodeString;
        if(theNewStudent.address.zipcode) {
            theNewStudent.address.zipcode.toString() === '0' ? zipCodeString = '' : zipCodeString = theNewStudent.address.zipcode.toString()
        } else {
            theNewStudent.address.zipcode = '0'
        }

        let createCustomerVariables = 
            {
              "input": {
                "businessId": businessId,
                "name": theNewStudent.familyName,
                "firstName": theNewStudent.primaryParentName,
                "lastName": theNewStudent.familyName,
                "email": theNewStudent.primaryEmail,
                "address": {
                  "addressLine1": theNewStudent.address.addressLine1,
                  "addressLine2": theNewStudent.address.addressLine2,
                  "city": theNewStudent.address.city,
                  "postalCode": zipCodeString,
                  "provinceCode": stateCode,
                  "countryCode": "US"
                },
                "currency": "USD"
              }
            }
        
        return createCustomer({variables: createCustomerVariables})
        .then((res) => {
            return res.data.customerCreate.customer.id
        })
        .catch((err) => {
            setError({message: err.networkError.result.errors, status: err.networkError.result.errors})
            console.log(err.networkError.result.errors)
            return
        })
    }

    const addANewFamily = async () => {
        let theNewFamily = newStudent
        theNewFamily.waveCustomerId = await makeANewWaveClient(newStudent)
        callPost(`${baseUrl}/school-management`, {newStudent: theNewFamily}, pushItem)
        setNewStudent(false)
    }

    const removeAStudent = (id) => {
        setModal({...modal, students: modal.students.filter(student => student.studentId !== id)})
    }

    //CREATES THE DROP DOWN LIST OF TEACHERS
    const generateTeacherFilterList = () => {
        let correctTeacherList = []
        if(schoolQuery === "") {
            correctTeacherList = teachers
        } else {
            for(let i = 0; i < teachers.length; i++) {
                if(teachers[i].School === schoolQuery.toLowerCase()) {
                    correctTeacherList.push(teachers[i])
                }
            }
        }
        let filteredTeachers = correctTeacherList
        let theList = document.getElementById("in-student-db-teacher-filter")
        if(theList) {
            while(theList.hasChildNodes()) {
                theList.removeChild(theList.lastChild)
            }
            let theDefaultOption = document.createElement("option")
            theDefaultOption.value = ""
            theDefaultOption.text = "Teacher"
            theList.appendChild(theDefaultOption)
            for(let i = 0; i < filteredTeachers.length; i++) {
                let option = document.createElement("option")
                option.value = filteredTeachers[i].TeacherID
                option.text = filteredTeachers[i].Name
                theList.appendChild(option)
            }
        }
    }

    //CREATE INSTRUMENT FILTER DROPDOWN
    const generateInstrumentFilterList = () => {
        let correctTeacherList = []
        correctTeacherList = instruments
        let filteredTeachers = correctTeacherList
        let theList = document.getElementById("in-student-db-instruments-filter")
        if(theList) {
            while(theList.hasChildNodes()) {
                theList.removeChild(theList.lastChild)
            }
            let theDefaultOption = document.createElement("option")
            theDefaultOption.value = ""
            theDefaultOption.text = "Instrument"
            theList.appendChild(theDefaultOption)
            for(let i = 0; i < filteredTeachers.length; i++) {
                let option = document.createElement("option")
                option.value = filteredTeachers[i].parentInstrument
                option.text = filteredTeachers[i].name
                theList.appendChild(option)
            }
        }
    }

    const compare = (a, b) => {
        if (a.familyName < b.familyName) {
          return -1;
        }
        if (a.familyName > b.familyName) {
          return 1;
        }
        return 0;
    }

    const alphabetizeStudents = () => {
        setStudentData([...studentData.sort(compare)])
    }

    const tallyUpStudentsByInstrument = (allStudents) => {
        let instruments = {}
        let total = 0
        for(let i = 0; i < allStudents.length; i++) {
            for(let k = 0; k < allStudents[i].students.length; k++) {
                for(let j = 0; j < allStudents[i].students[k].instrumentList.length; j++) {
                    total++
                    instruments[allStudents[i].students[k].instrumentList[j].parentInstrument] ? instruments[allStudents[i].students[k].instrumentList[j].parentInstrument]++ : instruments[allStudents[i].students[k].instrumentList[j].parentInstrument] = 1
                }
            }
        }
        setTotalInst(total)
        setInstrumentTotals(instruments)
    }

    const generateTotals = () => {
        //SET TOTALS BACK TO 0
        setTotals({'MMA': 0, 'LSMA': 0, 'TMA': 0, 'MOR': 0})
        //GENERATE TOTALS
        for(let i = 0; i < allStudents.length; i++) {
            if(allStudents[i].familyStatus === "Active") {
                for(let j = 0; j < allStudents[i].students.length; j++) {
                    allStudents[i].students[j].studentStatus === 'Active' && setTotals(prev =>  ({...prev, [allStudents[i].school]: prev[allStudents[i].school] + 1}))
                }
            }
        }
    }

    const quickTempFunc = () => {
        let myMap = {}
        for(let i = 0; i < allStudents.length; i++) {
            if(allStudents[i].familyStatus === 'Active') {
                for(let j = 0; j < allStudents[i].students.length; j++) {
                    if(allStudents[i].students[j].studentStatus === 'Active') {
                        if(myMap[allStudents[i].students[j].allRates[30]]) {
                            myMap[allStudents[i].students[j].allRates[30]] = myMap[allStudents[i].students[j].allRates[30]] + 1
                        } else {
                            console.log('hi')
                            myMap[allStudents[i].students[j].allRates[30]] = 1
                        }
                    }
                }
            }
        }
        console.log(myMap)
    }

    return(
        <div className="student-database" style={{backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(' + background + ')'}}>
            {/* {loading && <NewLoadingScreen message={"Updating database..."}/>} */}
            {closingModal && <div className='cover-up-everything-to-stop-double-click'></div>}
            {/* <h1 onClick={() => quickTempFunc()}>Click to Run</h1> */}
            <div className="student-db-title">Student Database</div>
            <div className="add-search-wrapper">
                <div className="add-student-btn" onClick={() => openNewFamily()}>+ New Family</div>
                <input className="student-search" placeholder="Search Student or Family" id="student-search" value={nameQuery} onChange={(e) => setNameQuery(e.target.value)} />
            </div>
            <div className="filters-wrapper">
                <input className='phone-number-search' placeholder='Search Phone #' value={phoneNumberQuery} onChange={(e) => setPhoneNumberQuery(e.target.value)} />
                {/* <input className="instrument-student-search" placeholder="Instrument Search" value={instrumentQuery} onChange={(e) => setInstrumentQuery(e.target.value)} /> */}
                <select className="student-db-filter" id="in-student-db-instruments-filter" onChange={(e) => setInstrumentQuery(e.target.value)}>
                    <option value="" default>Instrument</option>
                </select>
                <select className="student-db-filter" id="in-student-db-teacher-filter" onChange={(e) => setTeacherQuery(e.target.value)}>
                    <option value="" default>Teacher</option>
                </select>
                <select className="student-db-filter" id="school-selector" onChange={(e) => setSchoolQuery(e.target.value)} >
                    <option value="" default>School</option>
                    <option value="MMA">Mountainside</option>
                    <option value="LSMA">Lakeside</option>
                    <option value="TMA">Treeside</option>
                    <option value="MOR">Morningside</option>
                    <option value="PSMA">Parkside</option>
                </select>
                <select className="student-db-filter last-filter" id="status-filter" onChange={(e) => setStatusQuery(e.target.value)}>
                    <option value="" default>Status</option>
                    <option value="Active" default>Active</option>
                    <option value="Being Onboarded">Being Onboarded</option>
                    {/* <option value="Prospective">Prospective</option> */}
                    <option value="Waitlist">Waitlist</option>
                    <option value="Taking a Break">Taking a Break</option>
                    <option value="Summer Break">Summer Break</option>
                    <option value="Scholarship">Scholarship</option>
                    <option value="Needs New Teacher">Needs New Teacher</option>
                    <option value="Left the School">Left the School</option>
                    <option value="Inquired">Inquired</option>
                </select>
            </div>
            <div className="admin-dashboard-box student-db-box">
                <div className="searchbars-wrapper student-searchbars">
                </div>
                <div className="student-db-btn-wrapper">
                    <div className="add-email-btn" onClick={() => copyAttempt()}>COPY EMAILS</div>
                </div>
                {!gettingStudents && <div className="the-table-wrapper">
                    <table className="student-table">
                        <thead className='student-database__column-titles'>
                            <tr>
                                <th><input onClick={(e) => massCheck(e.target.checked)} type="checkbox" /></th>
                                <th style={{cursor: "pointer"}} onClick={() => alphabetizeStudents()}>Family</th>
                                <th>Email</th>
                                <th className='cell-phone__column'>Cell Phone</th>
                                <th>Kids</th>
                                <th>School</th>
                                <th className='status__column'>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                [...studentData].reverse().map(row => {
                                    if(row.familyName !== '*autogenerated*') {
                                        return(
                                            <tr key={row.familyId} className="student-database__each-row">
                                                <td><input className={"student-checkbox"} type="checkbox" value={row.primaryEmail}/></td>
                                                <td onClick={() => openStudentModal(row.familyId)}>{row.familyName}{row.moreAttention && <img alt='millie' src='millie_bobby_brown_alert.jpg' className='mini-bobby-brown-alert' />}</td>
                                                <td onClick={() => openStudentModal(row.familyId)}>{row.primaryEmail}</td>
                                                <td onClick={() => openStudentModal(row.familyId)}>{row.primaryCellphone}</td>
                                                <td onClick={() => openStudentModal(row.familyId)}>{row.students && row.students.length}</td>
                                                <td onClick={() => openStudentModal(row.familyId)}>{row.school}</td>
                                                <td onClick={() => openStudentModal(row.familyId)}>{row.familyStatus}</td>
                                            </tr>
                                        )
                                    } else {
                                        return (
                                            null
                                        )
                                    }
                                })
                            }
                        </tbody>
                    </table>
                </div>}
                {gettingStudents && <div className="the-table-wrapper">
                    <div className="student-database-loading-wrapper">
                        <img className="loading-ping" src={loadingping} />
                    </div>
                </div>}            
            </div>
            <div className="student-database__school-totals">
                <div className="student-database__each-school-total">MMA: {totals['MMA']}</div>
                <div className="student-database__each-school-total">LSMA: {totals['LSMA']}</div>
                <div className="student-database__each-school-total">TSMA: {totals['TMA']}</div>
                <div className="student-database__each-school-total">MOR: {totals['MOR']}</div>
                <div className="student-database__each-school-total">TOTAL: {totals['MMA'] + totals['LSMA'] + totals['TMA'] + totals['MOR']}</div>
            </div>
            <div style={{width: '80%', margin: '0px 10% 200px 10%'}}>
                {Object.keys(instrumentTotals).map((instrument, i) => 
                    <div key={i} className="student-database__instrument-totals" style={{backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'inline-block', padding: '5px', margin: '5px 10px', borderRadius: '10px'}}>
                        <div className="student-database__each-instrument-total">{instrument}: {instrumentTotals[instrument]}|{Math.round((instrumentTotals[instrument]/totalInst) * 100)}%</div>
                    </div>
                )}
            </div>
            {missingRatesPopup && <MissingStudentRatePopup setMissingRatesPopup={setMissingRatesPopup} />}
            {newStudent && <NewStudentModal key={newStudent.familyId} newFamily={newStudent} removeAStudent={removeAStudent} addAStudent={addAStudent} addAnotherNewStudent={addAStudent} closeStudentModal={(id) => closeStudentModal(id)} setNewStudent={setNewStudent} addANewFamily={addANewFamily} editStudentInfo={editStudentInfo} teachers={teachers}/>}
            {modal && <StudentModal key={modal.familyId} setAreYouSure={setAreYouSure} removeAStudent={removeAStudent} addAStudent={addAStudent} family={modal} closeStudentModal={closeStudentModal} editStudentInfo={editStudentInfo} teachers={teachers} currentOpenStudents={currentOpenStudents} setCurrentOpenStudents={setCurrentOpenStudents} setInvoiceView={props.setInvoiceView} />}
            {areYouSure && <AreYouSure setAreYouSure={setAreYouSure} removeTheFamily={removeTheFamily}/>}
            {error && <ErrorPopup error={error} setError={setError} />}
        </div>
    )
}

export default StudentDatabase;